export default "__VITE_ASSET__Bqnp9q72__"